import { AppTopBar } from 'components/AppTopBar';
import { getTrans } from 'modules/i18n';
import {
  DateFormat,
  DEFAULT_TIMEZONE,
  formatDateWithTimezone
} from 'utils/date';
import { useShift } from '../hooks';

export const ShiftPageHeader = () => {
  const { shift, isLoading, isError } = useShift();

  const title = getTrans('pageTitles.shiftDetails');

  if (isLoading) {
    return <AppTopBar variant="back" title={title} />;
  }

  if (!shift || isError) {
    return <AppTopBar variant="back" />;
  }

  const subtitleWithTimezone = shift?.reportedShiftStart
    ? formatDateWithTimezone(
        shift.reportedShiftStart,
        DateFormat.WEEKDAY_WITH_MONTH,
        DEFAULT_TIMEZONE
      )
    : '';

  return (
    <AppTopBar variant="back" title={title} subtitle={subtitleWithTimezone} />
  );
};
